import React, {Component} from 'react';
import ColorPicker from './ColorPicker'

const ColorPickerField = (field) =>{ 

    let color = field.meta.dirty? field.color : field.meta.initial;
    color = color || '#000000'
    return (   
        <div>
            <ColorPicker  {...field} color={color} onChange={field.input.onChange} name={field.input.name}  />
        </div>
    )
}

export default ColorPickerField;


// WEBPACK FOOTER //
// app/components/ColorPickerField.jsx